import React, { useMemo } from 'react'
import { useComparatore, useTrans, useTealium, useIsMobile } from '@next-nx/hooks'
import { OffertaType } from '@next-nx/utils/types'
import { getTimestamp } from '@next-nx/utils'
import { WImage, Button, WContainer, OffertaCardTag, MainTitle } from '@next-nx/shared-ui/atoms'
import styles from './ProdottoHero.module.sass'
import Shuffle from '../../atoms/Icons/Shuffle'

interface Props {
  offerta: OffertaType
  className?: string
}

const ProdottoHero = (props: Props) => {
  const { offerta = undefined, className = '' } = props

  const t = useTrans()
  const isMobile = useIsMobile()
  const { maxCompareItems, compareItems, setCompareItems, setLimitReached } = useComparatore()
  const { linkDataLayer } = useTealium()

  const handleTracking = (product: string = '') => {
    const action_timestamp = getTimestamp()

    linkDataLayer({
      virtual: 'action',
      action_name: 'comparatore',
      action_tech: 'click',
      action_type: 'aggiungi_prodotto',
      action_timestamp,
      action_effect: 'aggiunta_prodotto_comparatore',
      cta: 'cta_pdp',
      product: product.replace(/ /g, '_').replace(/\./g, '').toLowerCase(),
    })
  }

  const imageBox = useMemo(
    () =>
      offerta && (
        <WImage
          src={offerta.veicolo.mainImmagineStatica}
          alt={offerta.nome}
          title={offerta.nome}
          maxWidth={566}
          maxHeight={340}
          layout="intrinsic"
        />
      ),
    [offerta?.nome]
  )

  return offerta ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={`${styles.layout}`}>
          <div className={styles.content}>
            <MainTitle label={offerta.veicolo.nome} color="white" />
            {!!offerta.veicolo.allestimento && (
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: offerta.veicolo.allestimento }}
              />
            )}
            <div className={styles.actions}>
              <div className={styles.tags}>
                {offerta.prontaConsegna && (
                  <OffertaCardTag label={t('Pronta consegna')} color="blue" />
                )}
                {offerta.gammaEcologica && (
                  <OffertaCardTag label={t('Gamma ecologica')} color="green" />
                )}
                {offerta.tuttoIncluso && (
                  <OffertaCardTag label={t('Tutto incluso')} color="purple" />
                )}
              </div>
              <div className={styles.compare}>
                <Button
                  label={t(
                    compareItems.filter((x) => x.pk === offerta.pk).length > 0
                      ? "Rimuovi l'auto dal confronto"
                      : "Aggiungi l'auto al confronto"
                  )}
                  icon={<Shuffle />}
                  variant="ghost"
                  color="white"
                  onClick={() => {
                    compareItems.filter((ci) => ci.pk === offerta.pk).length > 0
                      ? setCompareItems(compareItems.filter((ci) => ci.pk !== offerta.pk))
                      : compareItems.length < maxCompareItems
                      ? setCompareItems(compareItems.concat([offerta]))
                      : setLimitReached(true)
                    compareItems.filter((x) => x.pk === offerta.pk).length <= 0 &&
                      handleTracking(offerta.veicolo.allestimento ?? offerta.veicolo.nome)
                  }}
                  className={'funzionalità_confronta'.toHotjarFormat('{0}', isMobile)}
                />
              </div>
            </div>
          </div>
          <div className={`${styles.imageBox}`}>{imageBox}</div>
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default ProdottoHero
